import { createSelector } from 'redux-orm';

import orm from '../orm';

export const selectCardPointArchivedDataForCardAndPointSystem = createSelector(
  orm,
  (_, cardId) => cardId,
  (_, __, pointSystemId) => pointSystemId,
  ({ CardPointData, CardPointArchivedData }, cardId, pointSystemId) => {
    if (!cardId || !pointSystemId) {
      return null;
    }

    const cardPointDataModel = CardPointData.all()
      .filter({ cardId, pointSistemId: pointSystemId })
      .first();

    if (!cardPointDataModel) {
      return null;
    }

    const archivedModels = CardPointArchivedData.all()
      .filter({ cpdId: cardPointDataModel.id, pointSistemId: pointSystemId })
      .toModelArray();

    if (!archivedModels || archivedModels.length === 0) {
      return null;
    }

    // Если по каким-то причинам записей несколько — берем самую позднюю по taskClosedAt
    const latest = archivedModels.reduce((acc, model) => {
      const a = acc?.ref?.taskClosedAt ? new Date(acc.ref.taskClosedAt).getTime() : -Infinity;
      const b = model?.ref?.taskClosedAt ? new Date(model.ref.taskClosedAt).getTime() : -Infinity;
      return b > a ? model : acc;
    }, null);

    return latest ? latest.ref : null;
  },
);

export default {
  selectCardPointArchivedDataForCardAndPointSystem,
};

